import { Outlet, createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { ArrivalPage } from '@/features/schedule-data/ArrivalPage';
import { NotFoundPage } from '@/features/schedule-data/NotFoundPage';
import { ScheduledBusesPage } from '@/features/schedule-data/ScheduledBusesPage';
import type { AppEntry } from '@/app/routes-types';
import { SURFACES } from '@/lib/gql/__generated__/surfaces';
import { guardSurface } from '@/lib/platform/surfaces';

export const entry: AppEntry = { default: '/', byRole: {} };

const rootRoute = createRootRoute({
  component: Outlet,
  notFoundComponent: NotFoundPage,
});

const arrivalRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: ArrivalPage,
  beforeLoad: () => guardSurface(entry, SURFACES.arrival),
  staticData: { title: 'Seattle Bus Times', page: SURFACES.arrival, standalone: false, isPublic: true },
});

const scheduledBusesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/scheduled-buses',
  component: ScheduledBusesPage,
  beforeLoad: () => guardSurface(entry, SURFACES['scheduled-buses']),
  staticData: { title: 'Scheduled buses', page: SURFACES['scheduled-buses'], standalone: false, isPublic: true },
});

const routeTree = rootRoute.addChildren([arrivalRoute, scheduledBusesRoute]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
